import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter } from 'lucide-react';
import VisitorCounter from './VisitorCounter';

const Footer = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';
  return (
    <footer style={{
      background: 'var(--bg-primary)',
      borderTop: '1px solid var(--border-subtle)',
      padding: '60px 7.6923%',
      marginTop: '100px'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '40px'
      }}>
        {/* Company Info */}
        <div>
          <img 
            src="https://customer-assets.emergentagent.com/job_fd78a43a-475d-4d4e-ba79-642a920f6f2b/artifacts/wir97gbm_VDM%20Final%20Logo.png" 
            alt="VDM Business Innovations" 
            style={{
              height: '144px',
              objectFit: 'contain',
              marginBottom: '20px'
            }}
          />
          <p style={{
            fontSize: '16px',
            color: 'var(--text-secondary)',
            lineHeight: '1.6',
            marginBottom: '20px'
          }}>
            Innovating for Tomorrow — Enabling Businesses to Thrive through Smart Technology.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: 'var(--text-primary)',
            marginBottom: '20px'
          }}>
            Quick Links
          </h4>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ marginBottom: '12px' }}>
              <a href="#about" style={{
                color: 'var(--text-muted)',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-muted)'}
              >
                About Us
              </a>
            </li>
            <li style={{ marginBottom: '12px' }}>
              <a href="#solutions" style={{
                color: 'var(--text-muted)',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-muted)'}
              >
                Our Solutions
              </a>
            </li>
            <li style={{ marginBottom: '12px' }}>
              <a href="#industries" style={{
                color: 'var(--text-muted)',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-muted)'}
              >
                Industries
              </a>
            </li>
            <li style={{ marginBottom: '12px' }}>
              <a href="#contact" style={{
                color: 'var(--text-muted)',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-muted)'}
              >
                Contact
              </a>
            </li>
            <li style={{ marginBottom: '12px' }}>
              <Link to="/privacy-policy" style={{
                color: 'var(--text-muted)',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-muted)'}
              >
                Privacy Policy
              </Link>
            </li>
            <li style={{ marginBottom: '12px' }}>
              <Link to="/terms-of-service" style={{
                color: 'var(--text-muted)',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-muted)'}
              >
                Terms of Service
              </Link>
            </li>
            <li style={{ marginBottom: '12px' }}>
              <Link to="/website-disclaimer" style={{
                color: 'var(--text-muted)',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-muted)'}
              >
                Website Disclaimer
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: 'var(--text-primary)',
            marginBottom: '20px'
          }}>
            Contact Information
          </h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Mail size={18} color="var(--brand-primary)" />
              <span style={{ color: 'var(--text-secondary)', fontSize: '16px' }}>
                sandeep@vdmbi.org
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Phone size={18} color="var(--brand-primary)" />
              <span style={{ color: 'var(--text-secondary)', fontSize: '16px' }}>
                +91 8050518788
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
              <MapPin size={18} color="var(--brand-primary)" style={{ marginTop: '4px' }} />
              <span style={{ color: 'var(--text-secondary)', fontSize: '16px' }}>
                Indiranagar, Bangalore, 560038
              </span>
            </div>
          </div>
        </div>

        {/* Social Media */}
        <div>
          <h4 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: 'var(--text-primary)',
            marginBottom: '20px'
          }}>
            Follow Us
          </h4>
          <div style={{ display: 'flex', gap: '16px' }}>
            <a href="#" style={{
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '0px',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'var(--brand-primary)';
              e.currentTarget.querySelector('svg').style.color = '#000000';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
              e.currentTarget.querySelector('svg').style.color = 'var(--text-primary)';
            }}
            >
              <Linkedin size={20} color="var(--text-primary)" />
            </a>
            <a href="#" style={{
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '0px',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'var(--brand-primary)';
              e.currentTarget.querySelector('svg').style.color = '#000000';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
              e.currentTarget.querySelector('svg').style.color = 'var(--text-primary)';
            }}
            >
              <Twitter size={20} color="var(--text-primary)" />
            </a>
          </div>
        </div>
      </div>

      {/* Copyright + Visitor Counter */}
      <div style={{
        marginTop: '60px',
        paddingTop: '30px',
        borderTop: '1px solid var(--border-subtle)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '18px'
      }}>
        <VisitorCounter homepageOnly isHomepage={isHome} />
        <p style={{
          color: 'var(--text-muted)',
          fontSize: '14px',
          textAlign: 'center',
          margin: 0
        }}>
          © 2025 VDM Business Innovations Pvt Ltd. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;